// Libraries
import { Box, Typography } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React, { useState } from "react";

// Custom
import { TypographyVariants } from "Custom/StylesAppSpecific/TypographyVariants";
import { RoofSystemStyle } from "./RoofSystemStyle";

import { isNullOrUndefined } from "Custom/Utils/Utils";

import { DelcoteProducts } from "./RoofSystemSubViews/DelcoteProducts";
import { SeamsilProducts } from "./RoofSystemSubViews/SeamsilProducts";

import { BQSRadioButton } from "./../../Primitives/RadioButtons/BQSRadioButton";
import { BQSRadioButtons } from "./../../Primitives/RadioButtons/BQSRadioButtons";

import { RoofSystemViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/RoofSystemViewModel";

interface IProps {
    className?: string;
    viewModel: RoofSystemViewModel;
}

export const RoofSystem: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const typopgraphyVariants = TypographyVariants();
    const roofSystemStyle = RoofSystemStyle();

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Box className={roofSystemStyle.root}>
            <Typography className={typopgraphyVariants.productSelectorh2} variant="h2">
                Choose your roof refurbishment system
            </Typography>
            <BQSRadioButtons
                displayName=""
                execute={props.viewModel.setProductSelection}
                row={false}
                value={!isNullOrUndefined(props.viewModel.productSelection) ? props.viewModel.productSelection.value : undefined}
            >
                {props.viewModel.products.map((item) => (
                    <BQSRadioButton displayName={item.title} key={item.value} value={item.value} />
                ))}
            </BQSRadioButtons>
            {props.viewModel.canDisplayDelcote && (
                <DelcoteProducts
                    commonViewModel={props.viewModel.ProductsCommonViewModel}
                    delglazeViewModel={props.viewModel.DelglazeViewModel}
                    viewModel={props.viewModel.DelcoteProductsViewModel}
                />
            )}
            {props.viewModel.canDisplaySeamsil && (
                <SeamsilProducts
                    commonViewModel={props.viewModel.ProductsCommonViewModel}
                    delglazeViewModel={props.viewModel.DelglazeViewModel}
                    viewModel={props.viewModel.SeamsilProductsViewModel}
                />
            )}
        </Box>
    ));

    // #endregion Render Result
};
